import { Category } from "@/schema/free-assessment/Category";
import { Result, resultSchema } from "@/schema/free-assessment/Result";
import { UserInfo, userInfoSchema } from "@/schema/free-assessment/UserInfo";
import { getCookie, setCookie } from "cookies-next";

const ONE_DAY = 60 * 60 * 24;

export const saveUserInfo = (info: UserInfo) => {
  setCookie("info", JSON.stringify(info), { maxAge: ONE_DAY });
};

export const saveAssessmentPaperId = (id: number) => {
  setCookie("assessment_paper_id", id.toString(), { maxAge: ONE_DAY });
};

export const getUserInfo = () => {
  const info = getCookie("info");
  if (!info) return;
  const result = userInfoSchema.safeParse(JSON.parse(info));
  if (!result.success) return;
  return result.data;
};

export const getAssessmentPaperId = () => {
  const id = getCookie("assessment_paper_id");
  if (!id) return;
  const parsed = parseInt(id);
  if (isNaN(parsed)) return;
  return parsed;
};

const saveResult = (result: Result) => {
  setCookie("result", JSON.stringify(result), { maxAge: ONE_DAY });
};

export const calculateAssessmentResult = (categories: Category[]) => {
  let temp = categories.map((category) => {
    const subCategories = category.sub_categories.map((subCategory) => {
      const answers = subCategory.questions
        .filter(({ answer }) => answer && answer !== 3)
        .map(({ id, points, answer }) => ({ id, points, answer }));

      if (answers.length === 0) {
        return {
          id: subCategory.id,
          content: subCategory.content,
          points: null,
          perfectScore: 0,
        };
      }

      const points = answers.reduce((prev, curr) => {
        return curr.answer === 1 ? prev + curr.points : prev;
      }, 0);

      const perfectScore = answers.reduce((prev, curr) => {
        return prev + curr.points;
      }, 0);

      return {
        id: subCategory.id,
        content: subCategory.content,
        points,
        perfectScore,
      };
    });

    const points = subCategories.reduce((prev, curr) => {
      return prev + (curr.points ?? 0);
    }, 0);

    const perfectScore = subCategories.reduce((prev, curr) => {
      return prev + curr.perfectScore;
    }, 0);

    return {
      id: category.id,
      content: category.content,
      points,
      perfectScore,
      subCategories,
    };
  });

  const isAllNull = temp.every((item) => item.points === null);

  const totalPoints = temp.reduce((prev, curr) => {
    if (curr.points === null) {
      return prev;
    }
    return prev + curr.points;
  }, 0);

  const totalPerfectScore = temp.reduce(
    (prev, curr) => prev + curr.perfectScore,
    0,
  );

  const result: Result = {
    total:
      isAllNull || !totalPerfectScore
        ? 0
        : Math.round((totalPoints / totalPerfectScore) * 100),
    categories: temp.map(
      ({ id, content, points, perfectScore, subCategories }) => ({
        id,
        content,
        points:
          points === null || !perfectScore
            ? 0
            : Math.round((points / perfectScore) * 100),
        subCategories: subCategories.map(
          ({ id, content, points, perfectScore }) => ({
            id,
            content,
            points:
              points === null || !perfectScore
                ? 0
                : Math.round((points / perfectScore) * 100),
          }),
        ),
      }),
    ),
  };

  saveResult(result);
};

export const getAssessmentResult = (): Result | undefined => {
  const assesmentResult = getCookie("result");
  if (!assesmentResult) return;
  const result = resultSchema.safeParse(JSON.parse(assesmentResult));
  if (!result.success) return;
  return result.data;
};

export const sendAppliedForm = async (info: {
  firstName: string;
  lastName: string;
  company: string;
  email: string;
  phone: string;
  message?: string;
}) => {
  console.log(info);
  return true;
};
